import type { AuthConfig } from '@next-social-platform/chatbot_sso';

// chatbot_sso OAuth (OIDC authorization-code + PKCE) config — Pattern A from the
// SDK INTEGRATION.md. The client_id is registered server-side via the SSO admin
// UI; an operator must register this app's redirect_uri (origin + '/') on that
// client record. The SDK restores the post-login path internally, so a single
// fixed redirect URI per environment is enough.
const SSO_ORIGIN = (import.meta.env.VITE_SSO_ORIGIN ?? 'https://sso.chatbot.mn').replace(/\/$/, '');
const CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID ?? 'hub';

export const authConfig: AuthConfig = {
  client_id: CLIENT_ID,
  redirect_uri: window.location.origin + '/',
  authorization_endpoint: `${SSO_ORIGIN}/api/oidc/authorize`,
  token_endpoint: `${SSO_ORIGIN}/api/oidc/token`,
  userinfo_endpoint: `${SSO_ORIGIN}/api/oidc/userinfo`,
  end_session_endpoint: `${SSO_ORIGIN}/api/oidc/logout`,
  issuer: SSO_ORIGIN,
  scope: 'openid profile email',
  debug: import.meta.env.DEV,
};
